// ******** Perfil.jsx *********
// ******** autor: Walcledson de Paula
// ******** data: 10/06/24 23h25
// ******** data: 04/07/24 12h01 implementação da criptografia nas variáveis globais
// ******** data: 09/07/24 23h11 implementação do tirar/carregar foto
// ***********************************

import { useEffect, useState, useRef } from "react";
import apiaxios from "../../../../Services/apiaxios.js";
import handleApiError from "../../../../Services/apiErrorHandler.js";
import { AutoLogout } from "../../../../Services/autologout.js";
import InputMask from 'react-input-mask';
import { decrypt } from "../../../../Services/cryptoUtils.js";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import CardFotoPerfil from "../../../AgendexCliente/components/Perfil/fotoperfil.jsx"; // Importe o componente CardFotoPerfil
import Menu from "../../Components/Menu/p_menu.jsx";
import Footer from "../../../AgendexCliente/components/Footer/footer.jsx";

import './p_perfil.css';
import { p_getUserData } from "../../../../Services/p_userutils.js";

function Perfil() {
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        const tokenlg = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, []);

    // ***** linhas abaixo substituídas por apenas 2 14/10/24w 11h32
    // const getInitialUserData = () => {
    //     const encryptedUser = localStorage.getItem('tokenapw');
    //     if (encryptedUser) {
    //         try {
    //             const decryptedUser = decrypt(encryptedUser);
    //             return {
    //                 userId: decryptedUser.id_usuario || 0,
    //                 // cidade: decryptedUser.cidade || ''
    //             };
    //         } catch (error) {
    //             console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
    //             // return { userId: 0, cidade: '' };
    //             return { userId: 0 };
    //         }
    //     }
    //     // return { userId: 0, cidade: '' };
    //     return { userId: 0 };
    // };

    // const initialUserData = getInitialUserData();
    // // const [cidade, setCidade] = useState(initialUserData.cidade);
    // const [id_usuario, setIdUsuario] = useState(initialUserData.userId); // Usar setIdUsuario para atualizar o id_usuario
    // ***** linhas acima substituídas por apenas essas 2 linhas abaixo 14/10/24 11h33
    const initialUserData = p_getUserData();
    const [id_usuario, setIdUsuario] = useState(initialUserData.userId); // Usar setIdUsuario para atualizar o id_usuario

    const [loading, setLoading] = useState(false);
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [fone, setFone] = useState('');
    const [uf, setUf] = useState('');
    const [pais, setPais] = useState('');
    const [cidade, setCidade] = useState('');
    const [ativaconta, setAtivaconta] = useState(0);
    const [avaliacoes, setAvaliacoes] = useState(0);
    const [qtavaliacoes, setQtavaliacoes] = useState(0);
    const [fotoPerfil, setFotoPerfil] = useState(null);

    const [isEditable, setIsEditable] = useState(false);
    const [showValidationDialog, setShowValidationDialog] = useState(false);

    const [validationCode, setValidationCode] = useState('');
    const [generatedCode, setGeneratedCode] = useState('')
    const [senha, setSenha] = useState('');
    const [confirmaSenha, setConfirmaSenha] = useState('');
    const [showCardFotoPerfil, setShowCardFotoPerfil] = useState(false); // Novo estado

    const foneRef = useRef(null);

    useEffect(() => {
        // alert(`id_usuario: ${id_usuario}`);
        carregaDados(id_usuario);
    }, [id_usuario]); // Adicionar id_usuario como dependência para recarregar dados quando ele mudar

    const MySwal = withReactContent(Swal);

    const carregaDados = async (idUsuario) => {
        setLoading(true);
        try {
            const response = await apiaxios.post('/usuario/perfilWeb', {
                id_usuario: idUsuario, // Usar idUsuario aqui
                tipo_app: 1
            },
            {
                params: {
                    id_usuario: idUsuario,
                    token: tokenASW
                }
            });

            if (response.status === 200) {
                const data = response.data;
                if (data.retorno === 'OK') {
                    setNome(data.nome);
                    setEmail(data.email);
                    setFone(data.fone);
                    setCidade(data.cidade);
                    setUf(data.uf);
                    setPais(data.pais);
                    // setAtivaconta(data.ativa_conta);
                    setAtivaconta(Number(data.ativa_conta));
                    setAvaliacoes(data.avaliacoes);
                    setQtavaliacoes(data.qtavaliacoes);
                    setFotoPerfil(`data:image/jpeg;base64,${data.foto64}`);
                    // alert(ativa_conta);
                    // alert(data.ativa_conta);
                } else {
                    Swal.fire('Erro', data.retorno, 'error');
                }
            } else {
                Swal.fire('Erro', 'Falha ao carregar seus dados. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const renderStars = (avaliacoes) => {
        let stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push(
                <i key={i} className={`fa fa-star ${i <= avaliacoes ? 'filled' : ''}`}></i>
            );
        }
        return stars;
    };

    const renderQtAvaliacoes = (qtavaliacoes) => {
        if (qtavaliacoes === 0) return "Você ainda não foi avaliado por nenhum cliente";
        if (qtavaliacoes === 1) return "Você possui 1 avaliação";
        if (qtavaliacoes > 1) return `Você possui ${qtavaliacoes} avaliações`;
        // alert(qtavaliacoes);
    };
    
    const handleFotoChange = (userId) => {
        setShowCardFotoPerfil(true); // Atualize o estado para mostrar o CardFotoPerfil
    };

    const handleEditProfile = () => {
        setIsEditable(true);
        setTimeout(() => {
            // if (foneRef.current) {
            //     foneRef.current.focus();
            // }
            if (foneRef.current && foneRef.current.inputElement) {
                foneRef.current.inputElement.focus();
            }
        }, 0);
    };

    const handleCancelEdit = () => {
        setIsEditable(false);
    };

    const atualizarcadastro = async () => {
        const generatedCode = Math.floor(100000 + Math.random() * 900000);
        setGeneratedCode(generatedCode.toString());
       
        try {
            const response = await apiaxios.post('/usuario/ValidaEmailWeb', {
                email: email,
                nome: nome,
                codigo: generatedCode
            },
            {
                params: {
                    id_usuario: id_usuario,
                    token: tokenASW
                }
            });

            if (response.status === 200 && response.data.retorno === 'OK') {
                MySwal.fire({
                    title: 'Código de Validação',
                    html: `<input type="number" id="validationCode" class="swal2-input" placeholder="Digite o código de validação">`,
                    showCancelButton: true,
                    confirmButtonText: 'Salvar Dados',
                    cancelButtonText: 'Cancelar',
                    preConfirm: () => {
                        const validationCode = Swal.getPopup().querySelector('#validationCode').value;
                        if (!validationCode) {
                            Swal.showValidationMessage('Por favor, insira o código de validação');
                        } else if (validationCode.length !== 6) {
                            Swal.showValidationMessage('O código deve ter exatamente 6 números');
                        } else if (validationCode !== generatedCode.toString()) {
                            Swal.showValidationMessage('Código de validação incorreto. Tente novamente.');
                        } else {
                            return { validationCode: validationCode };
                        }
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        handleAtivaConta();
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        handleCancelEdit();
                    }
                });
            } else {
                Swal.fire('Erro', 'Falha ao enviar o código de validação. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            handleApiError(error);
        }
    };

    const handleGenerateValidationCode = async () => {
        // Verifica se a senha está vazia ou tem menos de 3 caracteres
        if (!senha || senha.length < 6) {
            Swal.fire('Erro', 'Digite uma senha com pelo menos 6 caracteres.', 'error');
            return;
        }
        
        const generatedCode = Math.floor(100000 + Math.random() * 900000);
        setGeneratedCode(generatedCode.toString());
       
        try {
            const response = await apiaxios.post('/usuario/ValidaEmailWeb', {
                email: email,
                nome: nome,
                codigo: generatedCode
            },
            {
                params: {
                    id_usuario: id_usuario,
                    token: tokenASW
                }
            });

            if (response.status === 200 && response.data.retorno === 'OK') {
                MySwal.fire({
                    title: 'Código de Validação',
                    html: `<input type="number" id="validationCode" class="swal2-input" placeholder="Digite o código de validação">`,
                    showCancelButton: true,
                    confirmButtonText: 'Salvar Dados',
                    cancelButtonText: 'Cancelar',
                    preConfirm: () => {
                        const validationCode = Swal.getPopup().querySelector('#validationCode').value;
                        if (!validationCode) {
                            Swal.showValidationMessage('Por favor, insira o código de validação');
                        } else if (validationCode.length !== 6) {
                            Swal.showValidationMessage('O código deve ter exatamente 6 números');
                        } else if (validationCode !== generatedCode.toString()) {
                            Swal.showValidationMessage('Código de validação incorreto. Tente novamente.');
                        } else {
                            return { validationCode: validationCode };
                        }
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        handleSaveProfile();
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                        handleCancelEdit();
                    }
                });
            } else {
                Swal.fire('Erro', 'Falha ao enviar o código de validação. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            handleApiError(error);
        }
    };

    const handleAtivaConta = async () => {
        try {
            const response = await apiaxios.post('/usuario/AtivaContaWeb', {
                nome,
                email,
                tipoApp: 0
            },
            {
                params: {
                    id_usuario: id_usuario,
                    token: tokenASW
                }
            });

            if (response.status === 200 && response.data.retorno === 'OK') {
                Swal.fire('Sucesso', 'Conta ativada com sucesso!', 'success');
                setAtivaconta(1);
                handleCancelEdit();
            } else {
                Swal.fire('Erro', 'Falha ao ativar sua conta. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            console.error('catch handlesaveprovile', error);
            handleApiError(error);
        }
    };

    const handleSaveProfile = async () => {
        try {
            const response = await apiaxios.post('/usuario/AlteraSenhaWeb', {
                email,
                id_usuario,
                ativa_conta: 1,
                senha,
                fone
            },
            {
                params: {
                    id_usuario: id_usuario,
                    token: tokenASW
                }
            });

            if (response.status === 200 && response.data.retorno === 'OK') {
                Swal.fire('Sucesso', 'Dados atualizados com sucesso', 'success');
                handleCancelEdit();
            } else {
                Swal.fire('Erro', 'Falha ao atualizar seus dados. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            console.error('catch handlesaveprovile', error);
            handleApiError(error);
        }
    };

    const validatePhone = (input) => {
        return input.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
    };

    // useEffect(() => {
    //     console.log('Valor de ativaconta:', ativaconta, 'Tipo:', typeof ativaconta);
    // }, [ativaconta]);

    return (
        <div>
        {/* <h1>situação da conta: {ativa_conta}</h1>
        <h5>situação: {ativa_conta === 0 ? 'Você precisa validar seu email' : 'conta liberada para agendamentos'}</h5> */}
            <div className="container-fluid">
                <div className="row flex-nowrap">
                    <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                        <Menu page="perfil" />
                    </div>
                    <div className="col py-3 me-3">
                        <div className="text-center">
                            <h1>Meu Perfil</h1>
                        </div>
                        <hr />
                        <div className="perfil-info">
                            <div className="img-usuario text-center">
                                <img src={fotoPerfil} className="usuario-foto" alt="foto usuario" />
                                <button type="button" className="btn btn-primary btn-sm ml-10" onClick={() => handleFotoChange(id_usuario)}>Alterar Foto</button>
                                {showCardFotoPerfil && (
                                    // <div className="col py-2 me-3">
                                    <div className="col-lg-3 ml-10 col-md-4 col-sm-12">
                                        <CardFotoPerfil userId={id_usuario} />
                                    </div>
                                )}
                            </div>
                            <div className="perfil-detalhes">
                                <h4>{nome}</h4>
                                <div className="avaliacoes">
                                    <div className="stars">
                                        {renderStars(avaliacoes)}
                                    </div>
                                    <p>{renderQtAvaliacoes(qtavaliacoes)}</p>
                                </div>
                            </div>
                        </div>

                        <div className="box-perfil">
                            <form>
                                <div className="row mb-3">
                                    <label htmlFor="perfilnome" className="col-sm-2 col-form-label">Nome / id: {id_usuario}</label>
                                    <div className="col-sm-10">
                                        <input disabled type="text" className="form-control" id="perfilnome" placeholder="Nome completo do usuário" autoComplete="username" value={nome} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="perfilemail" className="col-sm-2 col-form-label">Email válido</label>
                                    <div className="col-sm-10">
                                        <input disabled type="email" className="form-control" id="perfilemail" placeholder="Email cadastrado no Agendex" autoComplete="email" value={email} />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <label htmlFor="perfilfone" className="col-sm-2 col-form-label">Telefone preferencial</label>
                                    <div className="col-sm-10">
                                        <InputMask
                                            mask={fone.length === 14 ? "(99)9999-9999" : "(99)99999-9999"}
                                            disabled={!isEditable}
                                            type="text"
                                            className="form-control"
                                            id="perfilfone"
                                            placeholder="Telefone (preferencial WhatsApp)"
                                            autoComplete="fone"
                                            value={fone}
                                            onChange={(e) => setFone(validatePhone(e.target.value))}
                                            ref={foneRef}
                                        />                                    
                                    </div>
                                </div>
                                
                                <div className="row mb-3">
                                    <label htmlFor="perfilcidade" className="col-sm-2 col-form-label">Cidade onde reside</label>
                                    <div className="col-sm-10">
                                        <input disabled={!isEditable} type="text" className="form-control" id="perfilcidade" placeholder="Cidade" autoComplete="address-level2" value={cidade} onChange={(e) => setCidade(e.target.value)} />
                                    </div>
                                </div>

                                <div className="row mb-3">      
                                    <label htmlFor="senha" className="col-sm-2 col-form-label">Nova Senha</label>
                                    <div className="col-sm-10">
                                        <input
                                            disabled={!isEditable}
                                            type="password"
                                            className="form-control"
                                            id="senha"
                                            placeholder="Nova Senha"
                                            value={senha}
                                            onChange={(e) => setSenha(e.target.value)}
                                            style={{ borderColor: senha && confirmaSenha && senha !== confirmaSenha ? 'red' : '' }}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="confirmaSenha" className="col-sm-2 col-form-label">Confirma Nova Senha</label>
                                    <div className="col-sm-10">
                                        <input
                                            disabled={!isEditable}
                                            type="password"
                                            className="form-control"
                                            id="confirmaSenha"
                                            placeholder="Confirma Nova Senha"
                                            value={confirmaSenha}
                                            onChange={(e) => setConfirmaSenha(e.target.value)}
                                            style={{ borderColor: senha && confirmaSenha && senha !== confirmaSenha ? 'red' : '' }}
                                        />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <label htmlFor="perfilconta" className="col-sm-2 col-form-label">Situação da conta</label>
                                    <div className="col-sm-10">
                                        <input disabled type="text" className={`form-control ${ativaconta === 0  ? 'btn btn-danger' : 'btn btn-success' }`} id="perfilconta" placeholder="situação da conta"
                                            value={`${ativaconta === 0 ? 'Você precisa validar seu email' : 'Conta liberada para oferecer agendamentos'}`}
                                        />
                                    </div>
                                </div>
                                {ativaconta === 0 && (
                                    <div className="row mb-3">
                                        <div className="col-sm-10">
                                            <button type="button" className="btn btn-warning" id="perfilativarconta" placeholder="ativar conta" onClick={atualizarcadastro} >Ativar Conta</button>
                                        </div>
                                    </div>
                                )}
                            </form>
                        </div>
                        <div className="d-flex justify-content-between">
                            <button type="button" className="btn btn-primary" onClick={handleEditProfile} disabled={isEditable}>Alterar dados do perfil</button>
                            <button type="button" className="btn btn-danger" onClick={handleGenerateValidationCode} disabled={!isEditable}>Gerar código de validação</button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Perfil;
